export default __webpack_public_path__ + "static/media/ZoeGamble.f1c28535.jpg";